import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import type { AdditionalNameInsuredDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/policycommon/additionalnameinsured/';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const additionalNameInsuredSelector = selector<AdditionalNameInsuredDTO[]>({
    key: 'additionalNameInsuredSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        if (!jobNumber || !sessionId) {
            throw new Error('Invalid quote- or session ID');
        }
        return await OnlineSales.getAdditionalNameInsured(jobNumber, sessionId);
    }
});
